import React from "react"
import styles from './Card.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';

class Card extends React.Component {
  render() {
    return(
        <div onClick={()=> window.open(this.props.link)} className="card">
          <LazyLoadImage height='100%' width={'100%'} effect="blur" placeholderSrc={this.props.img} src={this.props.img} />
          <div className="card-body">
          </div>
        </div>
    )
  }
}

export default Card